// Shared MG Swatches for the Raw Wood Finish Kit family.
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-RawWoodKits"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "180",
      "row_height_mobile": "140",
      "row_height_desktop": "180",
      "fit_row": false,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Rustic",
          "alt": "Rustic Raw Wood Finish Kit box front",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/75031525_800x800.jpg?v=1793636757",
          "product_url": "/products/raw-wood-finish-kit-rustic",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/raw-wood-finish-kit-rustic",
            "text": "Choose"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered",
          "alt": "Weathered Raw Wood Finish Kit box front",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/75743860_800x800.jpg?v=1793636235",
          "product_url": "/products/raw-wood-finish-kit-weathered",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/raw-wood-finish-kit-weathered",
            "text": "Choose"
          }
        }
      ],
      "heading": "",
      "subheading": ""
    }
  ]
};
